module.exports = __webpack_public_path__ + "static/media/master.fc20a63d.svg";